<oyan-ui-tab-nav-bar [centered]='true' [navLinks]="navLinks$ | async"></oyan-ui-tab-nav-bar>
<router-outlet></router-outlet>
